import { inject, Injectable } from '@angular/core';
import { DialogParams } from './models/dialog.model';
import { RdxDialogSelfRef, RdxDialogService } from '@radix-ng/primitives/dialog';
import { DialogComponent } from './components/dialog/dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private readonly service = inject(RdxDialogService);
  /**
   * The reference to the current dialog.
   * It is used to dismiss the previous dialog if the dismissPrevious flag is not false.
   */
  private _ref: RdxDialogSelfRef<void> | undefined;
  show(params: DialogParams) {
    /**
     * If the dismissPrevious flag is false, we don't dismiss the previous dialog.
     * This is useful for nested dialogs.
     */
    if (params.dismissPrevious !== false && this._ref) {
      this._ref.dismiss();
    }
    /**
     * Open the dialog.
     */
    this._ref = this.service.open({
      content: DialogComponent,
      data: params,
      modal: true,
      canCloseWithBackdrop: params.canCloseWithBackdrop ?? true,
    });

    return this._ref;
  }

}
